// code for reviews of home page by judge me app  starts

document.addEventListener("jdgm.doneSetup", function () {
  if (window.location.pathname !== "/") return;
  if (window.__jdgmCustomSetupDone__) return;
  window.__jdgmCustomSetupDone__ = true;

  const cssLink = document.createElement("link");
  cssLink.rel = "stylesheet";
  cssLink.href = "/path-to/style-jdgm-review.css";
  document.head.appendChild(cssLink);

  const formInterval = setInterval(() => {
    const titleInput = document.querySelector('input[name="review_title"]');
    const contentInput = document.querySelector('textarea[name="review_body"]');
    const nameInput = document.querySelector('input[name="reviewer_name"]');
    const emailInput = document.querySelector('input[name="reviewer_email"]');

    if (titleInput && contentInput && nameInput && emailInput) {
      titleInput.placeholder = "What did you love most?";
      contentInput.placeholder = "Share your experience or helpful tips...";
      nameInput.placeholder = "Your name";
      emailInput.placeholder = "name@example.com";
      clearInterval(formInterval);
    }
  }, 300);

  const container = document.querySelector('.jdgm-carousel__item-container');
  let jdgm_all_reviews_rating = document.querySelector('.jdgm-all-reviews-rating');
  let wc_judge_me_current_rating = document.querySelector('.wc_judge_me_current_rating');
  let wc_currnt_rating = jdgm_all_reviews_rating?.dataset?.score;
  if (wc_currnt_rating && !wc_judge_me_current_rating) {
    jdgm_all_reviews_rating.insertAdjacentHTML(
      'beforebegin',
      `<span class='wc_judge_me_current_rating'>${wc_currnt_rating}</span>`
    );
  }

  if (!container) return;
  if (container.classList.contains('swiper-initialized')) return;

  container.classList.add('swiper');
  const wrapper = container.querySelector('.jdgm-carousel__item-wrapper');
  const items = wrapper.querySelectorAll('.jdgm-carousel-item');
  wrapper.classList.add('swiper-wrapper');
  items.forEach(item => item.classList.add('swiper-slide'));

  let controlsWrapper = container.querySelector('.swiper-controls');
  if (!controlsWrapper) {
    controlsWrapper = document.createElement('div');
    controlsWrapper.className = 'swiper-controls';
    const prevBtn = document.createElement('div');
    prevBtn.className = 'swiper-button-prev';
    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination';
    const nextBtn = document.createElement('div');
    nextBtn.className = 'swiper-button-next';
    controlsWrapper.appendChild(prevBtn);
    controlsWrapper.appendChild(pagination);
    controlsWrapper.appendChild(nextBtn);
    container.appendChild(controlsWrapper);
  }

  new Swiper(container, {
    loop: false,
    spaceBetween: 20,
    slidesPerView: 1,
    speed: 500,
    navigation: {
      nextEl: container.querySelector('.swiper-button-next'),
      prevEl: container.querySelector('.swiper-button-prev'),
    },
    pagination: {
      el: container.querySelector('.swiper-pagination'),
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  });



  let wc_home_page_reviews_content = document.querySelectorAll(".jdgm-carousel-item__review-body");
console.log("wc_home_page_reviews_content", wc_home_page_reviews_content);

wc_home_page_reviews_content.forEach((review_content) => {
  let wc_review_containor = review_content.closest('.jdgm-carousel-item__review-wrapper');
  let wc_review_time = wc_review_containor.querySelector('.jdgm-carousel-item__timestamp.jdgm-ellipsis');
  let new_review_time_div = document.createElement('div');
  new_review_time_div.classList.add('wc_review_time');
  new_review_time_div.innerHTML = wc_review_time.innerHTML;
  review_content.insertAdjacentHTML('afterend',`<span class='wc_review_time'>${wc_review_time.innerHTML}</span>`); // ← correct method
});

});

// code for reviews of home page by judge me app

let wc_swiper_custom_click=(click_btn)=>{
  let swiper_containor=click_btn.closest('.swwiper_slider_containor , .wc_inspiration_section');
  let swiper_button_prev=swiper_containor.querySelector('.swiper_button_prev');
  let swiper_button_next=swiper_containor.querySelector('.swiper_button_next');
  let wc_hide_nav_prev_btn=swiper_containor.querySelector('.swiper-button-prev');
  let wc_hide_nav_next_btn=swiper_containor.querySelector('.swiper-button-next');
  if(click_btn.classList.contains('prev')){
    wc_hide_nav_prev_btn.click();
  }else{
    wc_hide_nav_next_btn.click();
  }
    if(wc_hide_nav_prev_btn.classList.contains('swiper-button-disabled')){
      swiper_button_prev.classList.add('wc_swiper_nav_disable');
    }else{
      swiper_button_prev.classList.remove('wc_swiper_nav_disable');
    }

    if(wc_hide_nav_next_btn.classList.contains('swiper-button-disabled')){
      swiper_button_next.classList.add('wc_swiper_nav_disable');
    }else{
      swiper_button_next.classList.remove('wc_swiper_nav_disable');
    }
}

let wc_enable_main_search_element=(click_ele)=>{
  let header__search=document.querySelector('.header__search details');
  if(header__search){
    header__search.setAttribute('open','true')
  }
}

// featured collection swiper js - home page -starts
var swiper = new Swiper(".wc_featured_collection_swiper_containor.mySwiper", {
  spaceBetween: 15, // Reduced slightly to fit narrower cards better on mobile
  loop: false,
  speed: 500,
  navigation: {
    nextEl: ".wc_featured_collection_swiper_containor .swiper-button-next",
    prevEl: ".wc_featured_collection_swiper_containor .swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.6, // Increased from 1.3 to make mobile slides narrower
      spaceBetween: 12,
    },
    480: {
      slidesPerView: 2.8, // Increased from 2
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 3.5, // Increased from 3
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4.5, // Increased from 4
      spaceBetween: 20,
    },
  },
});

// featured collection swiper js - home page -ends

//inspiration swiper code -starts

var swiper1 = new Swiper(".wc_inpiration_swiper_containor", {
  slidesPerView: 4,
  spaceBetween: 20,
  loop: false,
  watchOverflow: true,
  speed: 500,
  navigation: {
    nextEl: ".wc_inpiration_swiper_containor .swiper-button-next",
    prevEl: ".wc_inpiration_swiper_containor .swiper-button-prev",
  },
  pagination: {
    el: ".wc_inpiration_swiper_containor .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 'auto',
    },
  }
});
//inspiration swiper code -ends



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = document.querySelector('.wc_money_foramt').dataset.format;
wc_money_foramt = function(cents, format = Shopify.money_format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};